import { render, staticRenderFns } from "./Question4.vue?vue&type=template&id=819616bc&scoped=true&"
import script from "./Question4.vue?vue&type=script&lang=js&"
export * from "./Question4.vue?vue&type=script&lang=js&"
import style0 from "./Question4.vue?vue&type=style&index=0&id=819616bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "819616bc",
  null
  
)

export default component.exports